import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import ContextualMenu, { ContextualMenuButtons } from '../../components/ContextualMenu';
import DriveItemUtils from '../../utils/driveItem';
import { DriveItemInfo } from '../DriveItemList/reducer';

const mapStateToProps = (state: StoreState) => {
	const {
		driveList: {
			contextualMenu,
			contextualMenu: {
				isLocked,
			},
			driveItems,
		},
		galleryInfos: { template: { tagClasses } },
	} = state;
	let driveItem: DriveItemInfo | undefined;

	if (!contextualMenu.isOpened) {
		return {
			buttons: {} as ContextualMenuButtons,
			isOpened: false,
			isLocked,
			driveItem,
			tagClasses,
		};
	}

	const { driveItemId } = contextualMenu;
	driveItem = driveItems[driveItemId];
	const buttons = DriveItemUtils.getContextualMenuButtons(driveItem, state);

	return {
		buttons,
		isOpened: true,
		isLocked,
		driveItem,
		tagClasses,
	};
};

export default connect(mapStateToProps)(ContextualMenu);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ContextualMenu/index.tsx